import validateAndCreateHash from "@/helpers/sign/validateAndCreateHash.js";

export default async function(thumbprint, docsToSign){
    if (!window.cryptoPro) {
        throw new Error('CryptoPro is not initialized');
    }

    const { createDetachedSignature } = window.cryptoPro;

    let signed = {};
    const promises = [];
    for (const doc of docsToSign) {
        promises.push((async () => {
            const res = await axios.get(route('files', doc.file), { responseType: 'arraybuffer' });
            const hash = await validateAndCreateHash(res.data);
            const rawSig = await createDetachedSignature(thumbprint, hash);
            console.log(rawSig);
            const sig = rawSig.startsWith('-----BEGIN') ? rawSig : `-----BEGIN PKCS7-----\n${rawSig}\n-----END PKCS7-----\n`;
            signed[doc.id] = sig;
        })());
    }
    await Promise.all(promises);

    return signed;
}
